"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.castToAppleOrganisationInfoStatus = exports.AppleOrganisationInfoStatusSchema = exports.AppleOrganisationInfoStatus = exports.AppleAuthTokenSchema = exports.AppleAuthTokenFields = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../core");
const cast_1 = require("../../utils/cast");
exports.AppleAuthTokenFields = {
    accessToken: typebox_1.Type.String({
        description: "Token that can be used to authenticate with the Apple Search Ads API",
    }),
    tokenType: typebox_1.Type.Literal("Bearer"),
    expiresIn: typebox_1.Type.Integer({
        description: "Number of milliseconds the token is valid for",
        examples: [1200000, 1341692],
    }),
    scope: typebox_1.Type.Literal("searchadsorg"),
};
exports.AppleAuthTokenSchema = (0, core_1.StrictObject)(exports.AppleAuthTokenFields);
var AppleOrganisationInfoStatus;
(function (AppleOrganisationInfoStatus) {
    // Hosted by Redbox and available to anyone on the hosted tier
    AppleOrganisationInfoStatus["HOSTED_PUBLIC"] = "H";
    // Hosted by Redbox, by available to specific listed teams
    AppleOrganisationInfoStatus["HOSTED_PRIVATE"] = "P";
    // Client's organisation (hence private to listed teams)
    AppleOrganisationInfoStatus["CLIENT"] = "C";
    // Disabled and may not be used
    AppleOrganisationInfoStatus["DISABLED"] = "D";
})(AppleOrganisationInfoStatus = exports.AppleOrganisationInfoStatus || (exports.AppleOrganisationInfoStatus = {}));
exports.AppleOrganisationInfoStatusSchema = (0, core_1.StringUnion)([
    AppleOrganisationInfoStatus.HOSTED_PUBLIC,
    AppleOrganisationInfoStatus.HOSTED_PRIVATE,
    AppleOrganisationInfoStatus.CLIENT,
    AppleOrganisationInfoStatus.DISABLED,
], {
    title: "Apple Organisation Info Status",
});
exports.castToAppleOrganisationInfoStatus = (0, cast_1.castToEnum)(AppleOrganisationInfoStatus);
